import $ from 'jquery';
import * as cookieHelper from './cookieHelper';

export const init = () => {
	const $mobileAppBar = $('.js-mobile-app-bar');

	if (!$mobileAppBar.length) {
		return;
	}

	const $cross = $mobileAppBar.find('.mobile-app-bar__cross'),
		$icon = $mobileAppBar.find('.mobile-app-bar__icon'),
		$title = $mobileAppBar.find('.mobile-app-bar__header'),
		$floatCTA = $('.js-float-cta'),
		hiddenClassName = 'mobile-app-bar--hidden',
		hideBarCookieName = $mobileAppBar.data('cookie-name'),
		cookieExpirationDays = parseInt($mobileAppBar.data('cookie-expiration-days'));

	const operatingSystem = {
		android: 'Android',
		ios: 'iOS',
		unknown: 'unknown',
	};

	function hide() {
		$mobileAppBar.addClass(hiddenClassName);
		pushDataLayer('widgetClose');
	}

	function show() {
		$mobileAppBar.removeClass(hiddenClassName);
		pushDataLayer('widgetLoad');
	}

	function isHidden() {
		return $mobileAppBar.hasClass(hiddenClassName);
	}

	function close() {
		hide();

		const expirationDate = cookieHelper.getExpirationDateFromNow(cookieExpirationDays);
		cookieHelper.setCookie(hideBarCookieName, new Date().toISOString(), expirationDate);
	}

	function setUrls() {
		const currentOperatingSystem = getMobileOperatingSystem(),
			linkAndroid = $mobileAppBar.data('url-android'),
			linkIOS = $mobileAppBar.data('url-ios');

		switch (currentOperatingSystem) {
			case operatingSystem.ios:
				$icon.attr('href', linkIOS);
				$title.attr('href', linkIOS);
				break;
			default:
				$icon.attr('href', linkAndroid);
				$title.attr('href', linkAndroid);
				break;
		}
	}

	function getMobileOperatingSystem() {
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;

		if (/android/i.test(userAgent)) {
			return operatingSystem.android;
		}
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			return operatingSystem.ios;
		}
		return operatingSystem.unknown;
	}

	function getDLAppType() {
		switch (getMobileOperatingSystem()) {
			case operatingSystem.ios:
				return 'Apple';
			default:
				return 'Google';
		}
	}

	function pushDataLayer(event) {
		const dataLayerObject = {
			event: event,
			appType: getDLAppType(),
		};

		try {
			dataLayer.push(dataLayerObject);
		} catch (err) {
			console.error('Could not push data layer: ' + event);
		}
	}

	function checkVisibility() {
		const isVisible = !isHidden(),
			shouldBeVisible = getMobileOperatingSystem() !== operatingSystem.unknown;

		if (!isVisible && shouldBeVisible) {
			show();
		} else if (isVisible && !shouldBeVisible) {
			hide();
		}
	}

	function allowFloatCtaPopUp() {
		$floatCTA.removeClass('float-cta--hide');
		$floatCTA.removeClass('is-floaty');
	}

	function preventFloatCtaPopUp() {
		if (!$floatCTA.length || isHidden()) {
			return;
		}

		$floatCTA.addClass('float-cta--hide');
		$cross.on('click', allowFloatCtaPopUp);
	}

	function attachCallbacks() {
		// Close
		$cross.on('click', close);

		// Link click DL
		$.merge($title, $icon).on('click', () => pushDataLayer('widgetClick'));
	}

	setUrls();
	checkVisibility();
	preventFloatCtaPopUp();
	attachCallbacks();
};
